import { z } from 'zod';

export const printerMachineDisableSchema = z.object({
  disable_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type PrinterMachineDisableValidationSchema = z.infer<typeof printerMachineDisableSchema>;
